// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"962":"home","966":"login"}[chunkId] + "." + {"962":"435b9466","966":"bcbe3e5e"}[chunkId] + ".css";
};